function Home() {
  return (
    <>
      <style>{`
        .sb-landing {
          background: #263752;
          min-height: 100vh;
          display: flex;
          align-items: center;
          padding: 6rem 0;
        }

        .sb-landing-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 1.75rem;
          width: 100%;
        }

        .sb-landing-label {
          font-family: 'DM Sans', sans-serif;
          font-size: 0.75rem;
          font-weight: 600;
          color: #a8b8cc;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          margin: 0;
        }

        .sb-landing-heading {
          font-family: 'Noto Serif JP', serif;
          font-size: 3.5rem;
          font-weight: 700;
          color: #f8f8f8;
          letter-spacing: -0.03em;
          line-height: 1.1;
          margin: 0;
        }

        .sb-landing-divider {
          width: 48px;
          height: 3px;
          background: #a8b8cc;
          border-radius: 2px;
        }

        .sb-landing-subheading {
          font-family: 'DM Sans', sans-serif;
          font-size: 1.15rem;
          font-weight: 500;
          color: #a8b8cc;
          margin: 0;
          letter-spacing: 0.01em;
        }

        .sb-landing-cta {
          display: inline-block;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.9rem;
          font-weight: 600;
          color: #263752;
          background: #f8f8f8;
          padding: 0.7rem 2rem;
          border-radius: 8px;
          text-decoration: none;
          letter-spacing: 0.02em;
          margin-top: 0.5rem;
          transition: background 0.2s ease, transform 0.2s ease;
        }

        .sb-landing-cta:hover {
          background: #a8b8cc;
          transform: translateY(-1px);
        }

        @media (max-width: 767px) {
          .sb-landing {
            min-height: unset;
            padding: 8rem 0 5rem;
          }

          .sb-landing-heading {
            font-size: 2.25rem;
          }
        }
      `}</style>

      <section id="home" className="sb-landing" style={{"minHeight": "50vh"}}>
        <div className="sb-landing-inner">
          <p className="sb-landing-label mb-0">SweptBooks</p>
          <h1 className="sb-landing-heading">Bookkeeping Services</h1>
          <div className="sb-landing-divider" />
          <p className="sb-landing-subheading">Done By An Expert</p>
        </div>
      </section>
    </>
  );
}

export default Home;